import { ISession } from './session';

export type Primitive = string | null | number | boolean;
export type PrimitiveNotNull = string | number | boolean;

export type DataType =
    | 'Guid'
    | 'GuidArray'
    | 'Number'
    | 'Integer'
    | 'DateTime'
    | 'String'
    | 'FormattedString'
    | 'Boolean'
    | 'ImageId';

export enum EDataType {
    Guid = 'Guid',
    GuidArray = 'GuidArray',
    Number = 'Number',
    Integer = 'Integer',
    DateTime = 'DateTime',
    String = 'String',
    FormattedString = 'FormattedString',
    Boolean = 'Boolean',
    ImageId = 'ImageId',
}

export enum EImportablePolicies {
    'importAll' = 'importAll',
    'notImportable' = 'notImportable',
    'importSelection' = 'importSelection',
}

export enum EExportablePolicies {
    'exportAll' = 'exportAll',
    'notExportable' = 'notExportable',
    'exportSelection' = 'exportSelection',
}

export interface IDataset {
    name: string;
    dashboardTag?: string;
    dashboardSkipRoot?: boolean;
    dashboardHardCoded?: boolean;
    description?: string;
    obsolete: boolean;
    importable?: boolean;
    importablePolicy: EImportablePolicies;
    exportable?: boolean;
    exportablePolicy?: EExportablePolicies;
    hardCoded: boolean;
    released: boolean;
    advancedBindingKeys?: string[];
    controls: IDatasetControl[];
    childrenArray: IDataset[];
    childrenObject: IDataset[];
    internalNote?: string;
    sourceDisplayProperty?: string;
    isDynamicDataSource?: boolean;
    mainObjectChildren?: number;
    additionalConfigurationInfo?: string;
}

/** le foglie del dataset non hanno la prop dashboardSkipRoot*/
export interface IDatasetControl {
    name: string;
    dashboardTag?: string;
    dashboardHardCoded?: boolean;
    suggestedType: number;
    /** tipo di controllo da suggerire o settare di default se zero non ci sono suggerimenti */
    suggestedTypeDesc?: string;
    isReadOnly: boolean;
    isCalculated: boolean;
    isMandatory: boolean;
    hardCoded: boolean;
    released: boolean;
    obsolete: boolean;
    importable: boolean;
    exportable: boolean;
    /* IsNullable: false; */
    isNullable: boolean;
    label: string;
    binding: string;
    dataType: DataType; //deve sostituire jsonschematype
    jSonSchemaType?: string;
    itemsSource?: string;
    defaultValue?: Primitive;
    min?: number;
    max?: number;
    internalNote?: string;
    dynamicItemsSource?: string;
    additionalConfigurationInfo?: string;
}

export enum EDatasetType {
    'standard' = 'standard',
    'common' = 'common',
    'fixed' = 'fixed',
}

export enum EImportabilityType {
    'RestrictedImport' = 'RestrictedImport',
    'EnlargedImport' = 'EnlargedImport',
    'DisableImport' = 'DisableImport',
}

export interface IDatasetRootHeader {
    id: string;
    name: string;
    description: string;
    importability: EImportabilityType;
    createdOn?: string;
    modifiedOn?: string;
    isFixed: boolean;
    isCommon: boolean;
    rootName: string;
}

export interface IDatasetHeader {
    idType?: string;
    name: string;
    order: number;
    idFixed?: string;
    idCommon?: string;
    idFrom?: string;
    idRootNavigation?: IDatasetRootHeader;
    idSite?: string;
    description?: string;
    released?: boolean;
    fixReleased?: boolean;
    releaseNotes?: string;
    fixReleaseNotes?: string;
    rootName?: string;
    internalVersion?: string;
    siteVersion?: string;
    fixVersion?: string;
    createOn?: Date;
    modifiedOn?: Date;
    restRootName?: string;
    packageSession?: ISession | null;
    version?: string;
    imaging?: boolean;
}

export interface IDatasetHeaderTree {
    parentList: IDatasetHeader[];
    children: IDatasetHeaderChild[];
}

export interface IDatasetHeaderChild {
    item: IDatasetHeader;
    children: IDatasetHeaderChild[];
}

export const isDatasetNode = (x: unknown): x is IDataset => {
    return (
        typeof x === 'object' &&
        x !== null &&
        'childrenArray' in x &&
        Array.isArray(x.childrenArray) &&
        'childrenObject' in x &&
        Array.isArray(x.childrenObject) &&
        'controls' in x &&
        Array.isArray(x.controls)
    );
};
